(function () {
  'use strict';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var syncing = false, pending = null;
  var ME = document.currentScript && document.currentScript.src;

  function config() {
    var el = document.getElementById('ciub-cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function dismissed(t) { try { return sessionStorage.getItem('cx_gift_dismissed_' + t) === '1'; } catch (e) { return false; } }
  function dismiss(t) { try { sessionStorage.setItem('cx_gift_dismissed_' + t, '1'); } catch (e) {} }
  function undismiss(t) { try { sessionStorage.removeItem('cx_gift_dismissed_' + t); } catch (e) {} }

  /* ---------- delivery estimate ---------- */
  var ETA = { GB: { mode: 'by', days: 3 }, IE: { mode: 'by', days: 3 }, US: { mode: 'between', min: 3, max: 5 }, DEFAULT: { mode: 'between', min: 3, max: 5 } };
  function londonToday() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return new Date(p.year, p.month - 1, p.day);
  }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function wknd(d) { return d.getDay() === 0 || d.getDay() === 6; }
  function deliver(from, n) { var d = addDays(from, n); if (d.getDay() === 0) d = addDays(d, 1); return d; }
  function dayName(d, today) {
    var diff = (d - today) / 864e5;
    if (diff < 1) return 'Today';
    if (diff < 2) return 'Tomorrow';
    return d.toLocaleDateString('en-GB', { weekday: diff >= 7 ? 'short' : 'long' }) + (diff >= 7 ? ' ' + d.getDate() : '');
  }
  // shared rules (assets/ciub-eta.js) so the cart shows the same date as the product page and collections
  function loadEta() {
    if (window.ciubEta) return;
    document.addEventListener('ciub:eta-ready', fillEta);
    if (window.__ciubEtaLoading || !ME) return;
    window.__ciubEtaLoading = true;
    var s = document.createElement('script'); s.src = ME.replace(/[^\/]+\.js(\?.*)?$/, 'ciub-eta.js'); s.async = true;
    document.head.appendChild(s);
  }
  function fillEta() {
    var cfg = config(), els = document.querySelectorAll('[data-cx-eta]');
    if (!cfg || !els.length) return;
    var txt;
    if (window.ciubEta) txt = window.ciubEta.get(cfg.country).label;
    else {
      var rule = ETA[cfg.country] || ETA.DEFAULT;
      var today = londonToday();
      var dispatch = today; while (wknd(dispatch)) dispatch = addDays(dispatch, 1);
      if (rule.mode === 'by') txt = 'Arrives before ' + dayName(deliver(dispatch, rule.days), today);
      else txt = 'Arrives ' + deliver(dispatch, rule.min).toLocaleDateString('en-GB', { weekday: 'short' }) + '–' + deliver(dispatch, rule.max).toLocaleDateString('en-GB', { weekday: 'short' });
    }
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }

  /* ---------- rendering ---------- */
  function rerender(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (!parsed || !parsed.sections) return;
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(parsed);
    else {
      var html = new DOMParser().parseFromString(parsed.sections['cart-drawer'], 'text/html');
      var inner = html.querySelector('#CartDrawer'), target = document.querySelector('#CartDrawer');
      if (inner && target) target.innerHTML = inner.innerHTML;
    }
    if (drawer && parsed.item_count !== undefined) drawer.classList.toggle('is-empty', parsed.item_count === 0);
    fillEta();
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS, sections_url: window.location.pathname }, body)) }).then(function (r) { return r.json(); });
  }
  function addLine(id, props) { return post('/cart/add.js', { items: [{ id: id, quantity: 1, properties: props || {} }] }); }
  function setLine(key, qty) { return post('/cart/change.js', { id: key, quantity: qty }); }

  /* ---------- gift sync ---------- */
  var last = { g1: false, g2: false };
  function sync() {
    var cfg = config();
    if (!cfg || !cfg.ship) return Promise.resolve();
    if (syncing) { pending = true; return Promise.resolve(); }
    syncing = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var sub = 0, g1 = null, g2 = null, rogue = [];
      cart.items.forEach(function (it) {
        var g = it.properties && it.properties._gift;
        if (g === '1') g1 = it;
        else if (g === '2') g2 = it;
        else if (it.product_id === cfg.gift1Product || it.product_id === cfg.gift2Product) rogue.push(it);
        else if (!it.gift_card) sub += it.final_line_price;   // gift cards don't count towards free gifts
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) { sub -= d.total_allocated_amount || 0; });
      if (sub < 0) sub = 0;

      if (last.g1 && !g1 && sub >= cfg.gift1) dismiss(1);
      if (last.g2 && !g2 && sub >= cfg.gift2) dismiss(2);
      if (sub < cfg.gift1) undismiss(1);
      if (sub < cfg.gift2) undismiss(2);
      last = { g1: !!g1, g2: !!g2 };

      var chain = Promise.resolve(null), changed = false;
      function step(fn) { changed = true; chain = chain.then(fn); }

      // gift SKUs that didn't come from the gift logic are removed
      rogue.forEach(function (it) { step(function () { return setLine(it.key, 0); }); });

      // gift 1 — laundry bag
      if (sub >= cfg.gift1 && !dismissed(1) && cfg.gift1Variant) {
        if (!g1) step(function () { return addLine(cfg.gift1Variant, { _gift: '1' }); });
        else if (g1.variant_id !== cfg.gift1Variant) {
          step(function () { return setLine(g1.key, 0); });
          step(function () { return addLine(cfg.gift1Variant, { _gift: '1' }); });
        } else if (g1.quantity !== 1) step(function () { return setLine(g1.key, 1); });
      } else if (g1) step(function () { return setLine(g1.key, 0); });

      // gift 2 — hip pack mini
      if (sub >= cfg.gift2 && !dismissed(2) && cfg.gift2Variant) {
        if (!g2) step(function () { return addLine(cfg.gift2Variant, { _gift: '2' }); });
        else if (g2.variant_id !== cfg.gift2Variant) {
          step(function () { return setLine(g2.key, 0); });
          step(function () { return addLine(cfg.gift2Variant, { _gift: '2' }); });
        } else if (g2.quantity !== 1) step(function () { return setLine(g2.key, 1); });
      } else if (g2) step(function () { return setLine(g2.key, 0); });

      return chain.then(function () { if (changed) return post('/cart/update.js', {}).then(rerender); });
    }).catch(function () {}).then(function () {
      syncing = false;
      if (pending) { pending = false; setTimeout(sync, 50); }
    });
  }

  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (!syncing && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(function () { setTimeout(function () { sync(); fillEta(); }, 120); });
    return p;
  };

  /* ---------- upsell buttons + discount code ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cx-add]');
    if (btn) {
      btn.disabled = true; btn.textContent = 'Adding…';
      addLine(parseInt(btn.getAttribute('data-cx-add'), 10)).then(function () { return post('/cart/update.js', {}); }).then(rerender).then(sync);
      return;
    }
    // "Upgrade to the Bundle": swap one 4-Pack in the cart for the Bundle
    var swap = e.target.closest('[data-cx-swap]');
    if (swap) {
      swap.disabled = true; swap.textContent = 'Upgrading…';
      var key = swap.getAttribute('data-cx-swap-key'), qty = parseInt(swap.getAttribute('data-cx-swap-qty'), 10) || 1;
      syncing = true;   // hold the free-gift check until both steps are done
      addLine(parseInt(swap.getAttribute('data-cx-swap'), 10))
        .then(function () { return setLine(key, qty - 1); })
        .then(function () { return post('/cart/update.js', {}); })
        .then(rerender)
        .catch(function () {})
        .then(function () { syncing = false; return sync(); });
      return;
    }
    if (e.target.id === 'cx-code-apply') {
      var input = document.getElementById('cx-code-input'), msg = document.getElementById('cx-code-msg');
      var code = (input.value || '').trim(); if (!code) return;
      msg.textContent = 'Checking…';
      post('/cart/update.js', { discount: code }).then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return d.applicable && d.code.toUpperCase() === code.toUpperCase(); });
        if (ok) { rerender(cart); }
        else {
          msg.textContent = 'That code isn’t valid for this order';
          post('/cart/update.js', { discount: '' });
        }
      }).catch(function () { msg.textContent = 'Couldn’t apply that code'; });
      return;
    }
    if (e.target.id === 'cx-code-remove') {
      post('/cart/update.js', { discount: '' }).then(rerender);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'cx-code-input') { e.preventDefault(); document.getElementById('cx-code-apply').click(); }
  });

  function init() { loadEta(); fillEta(); setTimeout(sync, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', fillEta);
})();